// ════════════════════════════════════════════════════════════════════════
// QAPracticePage.tsx — Visor de guiones de preguntas frecuentes (Q&A)
// ════════════════════════════════════════════════════════════════════════
// A diferencia de los diálogos, aquí cada ítem es una pregunta típica con
// una respuesta modelo ya bilingüe. Una línea que empieza con "- " se
// muestra como viñeta en vez de párrafo.
// ════════════════════════════════════════════════════════════════════════

import { useParams, Link } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout/DashboardLayout';
import { AppSidebarMenu } from '../components/AppSidebarMenu/AppSidebarMenu';
import { findQAScript } from '../data/qaScripts';
import styles from './InterviewPracticePage.module.css';

function AnswerBlock({ text, className }: { text: string; className: string }) {
  const lines = text.split('\n');
  const isList = lines.every((l) => l.trim().startsWith('- '));

  if (isList) {
    return (
      <ul className={className} style={{ paddingLeft: '1.1rem', margin: 0 }}>
        {lines.map((l, i) => (
          <li key={i}>{l.replace(/^-\s*/, '')}</li>
        ))}
      </ul>
    );
  }

  return <p className={className}>{text}</p>;
}

export default function QAPracticePage() {
  const { slug } = useParams<{ slug: string }>();
  const script = findQAScript(slug);

  if (!script) {
    return (
      <DashboardLayout.Root>
        <DashboardLayout.Sidebar>
          <AppSidebarMenu />
        </DashboardLayout.Sidebar>
        <DashboardLayout.Content>
          <h1 className={styles.pageTitle}>Guion no encontrado</h1>
          <Link to="/dashboard/leads">Volver al panel</Link>
        </DashboardLayout.Content>
      </DashboardLayout.Root>
    );
  }

  return (
    <DashboardLayout.Root>
      <DashboardLayout.Sidebar>
        <AppSidebarMenu />
      </DashboardLayout.Sidebar>

      <DashboardLayout.Content>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>{script.title}</h1>
          <p className={styles.pageSubtitle}>{script.subtitle}</p>
        </div>

        <div className={styles.script}>
          {script.items.map((item, i) => (
            <div key={i} className={styles.turn}>
              <p className={styles.speaker} style={{ color: 'var(--brand-accent-dark)' }}>
                {item.title}
              </p>
              <AnswerBlock text={item.en} className={styles.en} />
              <AnswerBlock text={item.es} className={styles.es} />
            </div>
          ))}
        </div>
      </DashboardLayout.Content>
    </DashboardLayout.Root>
  );
}
